import {
  DELETE_USER_ACCOUNT_BEGIN,
  DELETE_USER_ACCOUNT_FAILURE,
  DELETE_USER_ACCOUNT_SUCCESS,
  KEY_FOR_USER_ID,
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';
import { toast } from 'react-toastify';

export function deleteUserAccount(id) {
  return dispatch => {
    dispatch({
      type: DELETE_USER_ACCOUNT_BEGIN,
    });
    const url = `${apiEndPoints.userManagement.DELETE_USER}?${KEY_FOR_USER_ID}=${id}`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.delete(url);
      doRequest.then(
        res => {
          dispatch({
            type: DELETE_USER_ACCOUNT_SUCCESS,
            data: {
              id: id,
            },
          });
          resolve(res);
        },
        err => {
          toast.error('User has not been deleted');
          reject(err);
          dispatch({
            type: DELETE_USER_ACCOUNT_FAILURE,
          });
        },
      );
    });
    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DELETE_USER_ACCOUNT_BEGIN:
      return {
        ...state,
        deleteUserAccountBegin: true,
        deleteUserAccountFailure: false,
        deleteUserAccountSuccess: false,
      };
    case DELETE_USER_ACCOUNT_SUCCESS:
      const { id } = action.data;
      return {
        ...state,
        deleteUserAccountBegin: false,
        deleteUserAccountFailure: false,
        deleteUserAccountSuccess: true,
        accounts: state.accounts.filter(a => {
          return a.id !== id;
        }),
      };
    case DELETE_USER_ACCOUNT_FAILURE:
      return {
        ...state,
        deleteUserAccountBegin: false,
        deleteUserAccountFailure: true,
        deleteUserAccountSuccess: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user-management/redux/deleteUserAccount.js